export const BlockRenderState = {
    Pending: 'pending',
    Queued: 'queued',
    Rendering: 'rendering',
    Failed: 'failed',
    Ready: 'ready',
    NoContent: 'no_content',
};
